export default {
  set_error(state, error) {
    state.errors = error;
  },
  set_fitting_types(state, {types}) {
    state.fitting_types = types.data;
    state.totalCount = types.total;
    state.count = types.total;
  },
  set_loading(state) {
    state.loading = true;
  },
  unset_loading(state) {
    state.loading = false;
  }
};
